import { filter, mergeMap } from 'rxjs/operators';

import { RootEpic } from '../../../store/epics';
import { ErrorType } from '../../../store/reducers/common';
import { recordConsent, recordConsentFail, recordConsentSuccess } from '../reducers/consent';

export const recordConsentEpic: RootEpic = (action$, state$, { api }) =>
  action$.pipe(
    filter(recordConsent.match),
    mergeMap(({ payload: { documentKeys, onSuccess } }) =>
      api.consent
        .recordConsent(documentKeys)
        .then(() => [recordConsentSuccess(), ...onSuccess])
        .catch((error: ErrorType) => [recordConsentFail(error)]),
    ),
    mergeMap((action) => action),
  );
